/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {StateDeclaration} from '@uirouter/core';

@Injectable({providedIn: 'root'})
export class NavigationHistoryService {
  previousState: StateDeclaration | null = null;
  previousParams: Record<string, any> = {};

  reset(): void {
    this.previousState = null;
    this.previousParams = {};
  }

  remember(state: StateDeclaration, params: Record<string, any>): void {
    this.previousState = state;
    this.previousParams = params || {};
  }
}
